import { render, staticRenderFns } from "./UnboxFilterSort.vue?vue&type=template&id=53227ab2&scoped=true"
import script from "./UnboxFilterSort.vue?vue&type=script&lang=js"
export * from "./UnboxFilterSort.vue?vue&type=script&lang=js"
import style0 from "./UnboxFilterSort.vue?vue&type=style&index=0&id=53227ab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53227ab2",
  null
  
)

export default component.exports